module.exports = __webpack_public_path__ + "img/map.9494395e.svg";